import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a promotional price (strikethrough original price,
 * discounted price, and a "Save X%" badge) for the current variant.
 * Listens for variant update events and swaps in the re-rendered price row.
 */
class PromotionPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the promotion price row.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    // Find the new promotion-price element in the updated HTML
    const newPromotionPrice = event.detail.data.html.querySelector(
      `promotion-price[data-block-id="${this.dataset.blockId}"]`
    );

    const currentRow = this.querySelector('[ref="row"]');

    if (!newPromotionPrice) {
      // No longer eligible for a promotion (e.g. block settings changed) - remove the row.
      currentRow?.remove();
      return;
    }

    const newRow = newPromotionPrice.querySelector('[ref="row"]');
    if (newRow && currentRow) {
      currentRow.replaceWith(newRow);
    } else if (newRow && !currentRow) {
      this.append(newRow);
    }
  };
}

if (!customElements.get('promotion-price')) {
  customElements.define('promotion-price', PromotionPrice);
}
